import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import StagedPremiumSettingsWizard from '../../components/PremiumSettings/stagedPremiumSettingsWizard'
import _ from 'lodash'
import { useState } from 'react'
import {
  changeLawsysFirmState,
  requestLawsysFirmsFiltered,
} from '../../actions/lawsysFirms'
import { stringToNumber } from '../../helpers/functions'
import {
  changeSubSettings,
  changeWizardData,
  getCoverageTypes,
} from '../../reducers/stagedPremiumsWizard'

const StagedPremiumSettingsWizardHOC = (props) => {
  const [currentStep, setStep] = useState(1)
  const [commissionModal, toggleCommissionModal] = useState(false)
  const dispatch = useDispatch()

  const changeData = (key, value) => {
    dispatch(changeWizardData({ key, value }))
  }
  const caseTypes = useSelector((state) => state.caseTypes)
  const lawsysFirms = useSelector((state) => state.lawsysFirms)
  const applicationPolicy = useSelector((state) => state.applicationPolicy)

  const stagedPremiumSettingsWizard = useSelector(
    (state) => state.stagedPremiumsWizard
  )

  const stagedSubSettings = Object.values(
    useSelector((state) => state.stagedPremiumsWizard.stagesSubSettings)
  )
  const agentsList = Object.values(
    useSelector((state) => state.stagedPremiumsWizard.agentCommissionsList)
  )
  const premiumSettingsWizard = useSelector(
    (state) => state.premiumSettingsWizard
  )
  const premiumSettings = useSelector((state) => state.premiumSettings)
  const caseTypeName = caseTypes?.cases.filter(
    (c) => c.id == premiumSettings.selectedCaseType
  )[0]?.name
  const subCaseTypeName = caseTypes?.subCases.filter(
    (c) => c.id == premiumSettings.selectedSubCaseType
  )[0]?.name
  const workSourceName = premiumSettings?.worksources.filter(
    (c) => c.id == premiumSettings.selectedWorksource
  )
  const stagedPremiums = useSelector((state) => state.stagedPremiums)
  const appStagedSubSettings = Object.values(
    useSelector((state) => state.stagedPremiums.stagesSubSettings)
  )
  const formIsFetching =
    stagedPremiumSettingsWizard.fetching ||
    stagedPremiumSettingsWizard.fetchingStagedPremium ||
    stagedPremiumSettingsWizard.fetchingCoverageTypes ||
    stagedPremiumSettingsWizard.fetchingStages

  useEffect(() => {
    dispatch(getCoverageTypes())
  }, [])

  useEffect(() => {
    if (lawsysFirms.suggestionFieldValue.length >= 3) {
      const askServer = setTimeout(() => {
        dispatch(
          requestLawsysFirmsFiltered({
            search: lawsysFirms.suggestionFieldValue,
          })
        )
      }, 500)
      return () => clearTimeout(askServer)
    }
  }, [lawsysFirms.suggestionFieldValue])

  const handleNextStep = () => {
    var validationError = ''
    changeData('errorResponse', '')
    const steps = [
      {
        step: 2,
        errorMessage:
          'Each Stage Premium & LOI cannot be less than the previous one',
        check: () =>
          stagedSubSettings.some(
            ({ limitOfIndemnity, premiumAmount }, index) =>
              index > 0 &&
              (parseFloat(limitOfIndemnity) <
                parseFloat(stagedSubSettings[index - 1].limitOfIndemnity) ||
                parseFloat(premiumAmount) <
                  parseFloat(stagedSubSettings[index - 1].premiumAmount))
          ),
      },
      {
        step: 2,
        errorMessage:
          'Please fill all the amount fields with values between $ 1 - $ 999,999,999',
        check: () =>
          stagedSubSettings.some(
            ({ limitOfIndemnity, premiumAmount }) =>
              !limitOfIndemnity ||
              !premiumAmount ||
              limitOfIndemnity < 1 ||
              premiumAmount < 1
          ),
      },
      {
        step: 2,
        errorMessage: 'Rates are required',
        check: () =>
          agentsList.some(
            ({ commissionPercentage }) => !commissionPercentage
          ) || !stagedPremiumSettingsWizard.underwriterRatePercentage,
      },
      {
        step: 2,
        errorMessage:
          "Sum of underwriter rate and the lawyer's commission rate must not exceed the premium.",
        check: () => {
          const commissionSum = agentsList.reduce(
            (sum, agent) =>
              parseFloat(sum) +
              parseFloat(agent.commissionPercentage.toString()),
            0
          )
          return (
            commissionSum +
              parseFloat(
                stagedPremiumSettingsWizard.underwriterRatePercentage.toString()
              ) >
            100
          )
        },
      },
      {
        step: 3,
        errorMessage: 'Please fill all the required fields',
        check: () =>
          !stagedPremiumSettingsWizard.selectedCoverageType ||
          !stagedPremiumSettingsWizard.selectedDeductible ||
          !stagedPremiumSettingsWizard.selectedEndorsement ||
          !stagedPremiumSettingsWizard.validFrom
      },
      {
        step: 3,
        errorMessage: 'Valid Until date cannot precede Valid From date',
        check: () =>
          stagedPremiumSettingsWizard.validFrom &&
          stagedPremiumSettingsWizard.validUntil &&
          new Date(stagedPremiumSettingsWizard.validFrom) >=
            new Date(stagedPremiumSettingsWizard.validUntil),
      },
    ]
    const stepCheck = steps.filter((s) => s.step === currentStep)
    stepCheck.map((c) => {
      c.check() == true ? (validationError = c.errorMessage) : null
    })

    if (validationError) {
      changeData('errorResponse', validationError)
    } else {
      changeData('errorResponse', validationError)
      setStep(currentStep + 1)
    }
  }

  const onSuggestionSelected = (value) => {
    let lawsysFirm = lawsysFirms.lawsysFirmsFiltered.find(
      (x) => x.id === value.value
    )
    dispatch(changeLawsysFirmState('lawsysFirmsFiltered', [lawsysFirm]))
    dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', [lawsysFirm]))
    dispatch(
      changeLawsysFirmState('selectedLawsysFirms', [
        ...lawsysFirms.selectedLawsysFirms,
        lawsysFirm,
      ])
    )
    changeData('selectedAgent', value.value)
  }

  const onSuggestionChange = (value, action) => {
    if (action.action !== 'input-blur' && action.action !== 'menu-close') {
      if (value.length < 3) {
        dispatch(changeLawsysFirmState('lawsysFirmsFiltered', []))
        dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', []))
        changeData('selectedAgent', '')
      }
      dispatch(changeLawsysFirmState('suggestionFieldValue', value))
    }
  }

  const addCommission = () => {
    let solicitorId = stagedPremiumSettingsWizard.selectedAgent
    let solicitorsList = [...agentsList]
    var commissionDetails = _.find(lawsysFirms.lawsysFirms, (item) => {
      return solicitorId.toString() === item.id.toString()
    })
    const agentDetails = {
      ...commissionDetails,
      commission: '',
      commissionPercentage: '',
    }
    solicitorsList.push(agentDetails)

    const newList = solicitorsList.reduce((values, agent) => {
      values[agent.id] = agent
      return values
    }, {})

    changeData('agentCommissionsList', newList)
    toggleCommissionModal(!commissionModal)
    dispatch(changeLawsysFirmState('suggestionFieldValue', ''))
    dispatch(changeLawsysFirmState('lawsysFirmsFiltered', []))
    dispatch(changeLawsysFirmState('selectedLawsysFirmsDropdown', []))
    changeData('selectedAgent', '')
  }

  //function that removes a solicitor from the list
  const removeSolicitor = (solicitorId) => {
    const solicitorsList = agentsList.filter((c) => c.id != solicitorId)
    const newList = solicitorsList.reduce((values, agent) => {
      values[agent.id] = agent
      return values
    }, {})

    changeData('agentCommissionsList', newList)
  }

  const amountColumnsDisplayDataPerStage = (stage) => {
    const commissionsAgentsData = agentsList.map((a) => ({
      title: a.name,
      value: `${'$'}${
        stringToNumber(a.commissionPercentage) *
        0.01 *
        stringToNumber(stage.premiumAmount)
      }`,
      isPlain: true,
      onChange: () => null,
    }))
    return [
      {
        title: 'Premium',
        value: stage.premiumAmount,
        isPlain: false,
        onChange: (e) =>
          dispatch(
            changeSubSettings({
              target: stage.stageMachineName,
              key: 'premiumAmount',
              value: e.target.value,
            })
          ),
      },
      {
        title: 'Limit of Indemnity',
        value: stage.limitOfIndemnity,
        isPlain: false,
        onChange: (e) =>
          dispatch(
            changeSubSettings({
              target: stage.stageMachineName,
              key: 'limitOfIndemnity',
              value: e.target.value,
            })
          ),
      },
      {
        title: 'Underwriter rate',
        value:
          stringToNumber(
            stagedPremiumSettingsWizard.underwriterRatePercentage
          ) *
          0.01 *
          stringToNumber(stage.premiumAmount),
        isPlain: true,
        onChange: () => null,
      },
      ...commissionsAgentsData,
    ]
  }
  return (
    <StagedPremiumSettingsWizard
      nextStep={handleNextStep}
      onEditStaged={props.onEditStaged}
      isEditStaged={props.isEditStaged}
      appStagedSubSettings={appStagedSubSettings}
      applicationPolicy={applicationPolicy}
      stagedPremiums={stagedPremiums}
      isChangingStatusOfApp={props.isChangingStatusOfApp}
      previousStep={() => {
        changeData('errorResponse', '')
        setStep(currentStep - 1)
      }}
      formIsFetching={formIsFetching}
      stagedSubSettings={stagedSubSettings}
      agentsList={agentsList}
      displayDataPerStage={amountColumnsDisplayDataPerStage}
      onSuggestionSelected={onSuggestionSelected}
      onSuggestionChange={onSuggestionChange}
      addCommission={addCommission}
      removeSolicitor={removeSolicitor}
      lawsysFirms={lawsysFirms}
      currentStep={currentStep}
      caseTypeName={caseTypeName}
      subCaseTypeName={subCaseTypeName}
      stagedPremiumSettingsWizard={stagedPremiumSettingsWizard}
      premiumSettingsWizard={premiumSettingsWizard}
      premiumSettings={premiumSettings}
      changeStageSubSetting={(target, key, value) =>
        dispatch(changeSubSettings({ target, key, value }))
      }
      changeStagedPremiumFormData={(key, value) => changeData(key, value)}
      handleSubmit={props.handleSubmit}
      onCancel={props.onCancel}
      isEdit={props.isEdit}
      isApplicationPremium={props.isApplicationPremium}
      workSourceName={workSourceName[0]?.name}
      commissionModal={commissionModal}
      toggleCommissionModal={() => toggleCommissionModal(!commissionModal)}
    />
  )
}

export default StagedPremiumSettingsWizardHOC
